<template>
  <div class="cards-totales-grid">
    <div class="card-total" v-for="(item, index) in totales" :key="index">
      <div>
        <span class="card-total-nombre">{{ item.nombre }}</span>
        <span class="card-total-valor">
          <span v-if="typeof item.total === 'number' || (!isNaN(Number(item.total)) && item.total !== '' && item.total !== null)">
            {{ formatoMonto(Number(item.total)) }}
          </span>
          <span v-else>
            {{ item.total }}
          </span>
        </span>
      </div>
      <div class="card-total-icon">
        <b-icon :icon="item.icono" size="is-large" />
      </div>
    </div>
  </div>
</template>
<script>
import Utiles from '../../Servicios/Utiles'
export default {
    name: "CartasTotales",
    props: ["totales"],
    methods: {
        formatoMonto(valor) {
            return Utiles.formatoMonto(valor)
        }
    }
}
</script>